import { Skeleton } from "primereact/skeleton";

const CardLoader = ({ height }) => (
    <div className="overflow-hidden">
        <Skeleton height={height} className="mb-1" />
        <div className="flex justify-between items-start">           
        </div>
    </div>
);
const BentoLoader = () => {
    return (
        <div className="mx-4 mt-5 grid grid-cols-1 lg:grid-cols-2 gap-5 lg:px-20">
            <CardLoader height="16rem" />
            <div className="grid grid-rows-2 gap-5">
                <CardLoader height="7rem" />
                <CardLoader height="7rem" />
            </div>

        </div>
    );
};

export default BentoLoader;